<template>
  <div id="app">
    <Header @setTitle="setTitle" :wxLogin="state.login" @update:wxLogin="wxLogin" v-if="showHeader"/>
    <a-config-provider :locale="zhCN">
      <router-view :title="state.title" @login="login" />
    </a-config-provider>
    <Footer />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import Header from '@/views/layout/header.vue';
import Footer from '@/views/layout/footer.vue';
import { useRoute } from 'vue-router';
import {reactive} from "vue";
const route = useRoute();
const showHeader = ref(true);
const state = reactive({
  title:'',//传递给首页搜索课程
  login:false,//传递给头部展示登录弹层
});
// 根据当前路由动态设置头部和尾部的显示
watch(() => route.path, (newPath) => {
  if (newPath === '/bindmobile') {
    showHeader.value = false;
  } else {
    showHeader.value = true;
  }
}, { immediate: true });

const login = () => {
  state.login = true;
}
const wxLogin = (value) => {
  state.login = value
}
const setTitle = (value) => {
  state.title = value;
}
</script>

<style scoped>
#app{
  background:#F8F8F8;
}
</style>
